import Vue from 'vue';
import OrdersService from '@/services/resources/orders.service';

export default new Vue({
  data() {
    return {
      changeStateTo: null,
    };
  },

  methods: {
    close(comment) {
      this.$emit('orders-close', this.changeStateTo, comment);
    },

    onAccept() {
      this.$emit('orders-on-accept');
      this.changeStateTo = OrdersService._STATE_ACCEPTED;
    },

    onCancel() {
      this.$emit('orders-on-cancel');
      this.changeStateTo = OrdersService._STATE_CANCELED;
    },

    onReject() {
      this.$emit('orders-on-reject');
      this.changeStateTo = OrdersService._STATE_REJECTED;
    },

    onChangingState(changing) {
      this.$emit('orders-on-changing-state', changing);
    },

    setNewState(state) {
      this.$emit('orders-new-state', state);
    },
  },
});
